import React, { ReactElement, ReactNode } from "react";
import Head from "next/head";
import { useModal } from "@hooks/useModalContext";
import dynamic from "next/dynamic";

import Header from "@components/shared/header";
import { useDomainContext } from "@hooks/useDomainContext";

import TalcumClaimsLogo from "@components/talcum/logo";
import Mobile from "@components/shared/blogPost/sideWidget/mobile";

const CloseIcon = dynamic(() => import("@components/svg/closeIcon"));
const Modal = dynamic(() => import("@components/shared/modal"));

const TermsAndConditions = dynamic(
    () => import("@components/shared/legal/termsAndConditions"),
);
const PrivacyPolicy = dynamic(
    () => import("@components/shared/legal/privacyPolicy"),
);

const Footer = dynamic(() => import("@components/shared/footer"));

export default function TalcumClaimsWrapper({
    children,
}: {
    children: ReactNode;
}): ReactElement {
    const { modal, closeModal } = useModal();
    const {
        visitDetails: { region },
    } = useDomainContext();
    const handleClose = () => {
        closeModal();
    };

    const { active: modalActive, content: modalContent } = modal;

    const getModalContent = () => {
        switch (modalContent) {
            case "privacy":
                return (
                    <PrivacyPolicy
                        category="Talcum"
                        domain="TalcumClaims.com"
                    />
                );
            case "terms":
                return (
                    <TermsAndConditions
                        category="Talcum"
                        domain="TalcumClaims.com"
                    />
                );
            case "sideWidget":
                return <Mobile />;
            default:
                return null;
        }
    };

    return (
        <>
            <Head>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap"
                    rel="stylesheet"
                />
            </Head>

            <div style={{ fontFamily: `'Open Sans', sans-serif` }}>
                <Header
                    textColor="#444B53"
                    slogan={`Find the Best Lawyers for Your Talcum Injuries ${
                        region ? `in ${region}` : ""
                    }`}
                >
                    <TalcumClaimsLogo />
                </Header>
                {children}
                <Footer />
                <Modal
                    onClose={handleClose}
                    active={modalActive}
                    closeIcon={<CloseIcon />}
                    backdropClosable
                    modalStyles={{
                        display: "flex",
                        flexDirection: "column",
                        maxHeight:
                            modalContent === "sideWidget" ? "80vh" : "100%",
                    }}
                    modalClassName="h-[90vh] rounded"
                    bodyStyles={{ overflowY: "scroll" }}
                    width={900}
                    header={
                        modalContent === "privacy"
                            ? "Privacy Policy"
                            : modalContent === "terms"
                            ? "Terms and Conditions"
                            : modalContent === "sideWidget"
                            ? "Contents"
                            : undefined
                    }
                >
                    {getModalContent()}
                </Modal>
            </div>
        </>
    );
}
